import styled from 'styled-components';

export const WalletCardWrapper = styled.div`
  ${({ theme }) => `
    padding: ${theme.space[4]}px;
    margin: 0 ${theme.space[4]}px ${theme.space[4]}px;
    border-radius: ${theme.space[2]}px;
    background-color: ${theme.color.lightYellow};
  `}
`;

export const WalletCardBalance = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => `
    margin-left: ${theme.space[3]}px;
  `}
`;

export const WalletCardFirstRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => `
    margin-bottom: ${theme.space[3]}px;
  `}
`;

export const WalletCardInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const WalletCardContent = styled.div`
  display: flex;
`;

export const StyledFixedDirectionWrapper = styled.div`
  direction: ltr;
`;
